module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.movies.length > 0) ? _c('div', {
    staticClass: "related-movies"
  }, [_c('sk-title-heading', {
    attrs: {
      "h2": "",
      "label": _vm.label
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('sk-button', {
    attrs: {
      "tag": "a",
      "secondary": "",
      "small": "",
      "inline-block": "",
      "href": _vm.link
    }
  }, [_vm._v("View All Movies")])], 1)], 2), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.slicedMovies), function(item, index) {
    return _c('sk-flex', {
      key: item.id,
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": "",
        "lg2": ""
      }
    }, [(_vm.$route.params.festival_id != undefined && _vm.$route.params.festival_id != null) ? [_c('a', {
      attrs: {
        "href": '/details/' + item.id + (_vm.$route.params.festival_id ? '/film-festival/' + _vm.$route.params.festival_id : '')
      }
    }, [_c('sk-movie-thumbnail', {
      ref: "movie",
      refInFor: true,
      attrs: {
        "now-showing": "",
        "content": item
      }
    })], 1)] : [_c('a', {
      attrs: {
        "href": '/details/' + item.id + '/' + item.title_slug
      }
    }, [_c('sk-movie-thumbnail', {
      ref: "movie",
      refInFor: true,
      attrs: {
        "now-showing": "",
        "content": item
      }
    })], 1)]], 2)
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73ec4be4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/related-movies/related-movies.vue
// module id = 838
// module chunks = 0